import type { User } from "@repo/types";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../Base/Dialog";
import { ContactForm, type ContactFormProps } from "./ContactForm";

export interface ContactDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  user?: User;
  onSubmit?: ContactFormProps["handleComplete"];
}

export const ContactDialog = ({
  open,
  setOpen,
  user,
  onSubmit,
}: ContactDialogProps) => (
  <Dialog open={open} onOpenChange={setOpen}>
    <DialogContent preventClickout preventEscape>
      <DialogHeader>
        <DialogTitle>Contact Us</DialogTitle>
      </DialogHeader>
      <ContactForm
        user={user}
        handleCancel={() => setOpen(false)}
        handleComplete={async (data) => {
          await onSubmit?.(data);
          setOpen(false);
        }}
        withinDialog
      />
    </DialogContent>
  </Dialog>
);
